<template>
    <div class="pt-15 animated chartOfAccount equipmentList fadeIn bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                   <gofix-card fullContent class="mb-0 heig-frame-child">
                        <gofix-default-table 
                            class="noFullHeight scrollAbsolute"
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @new-item="createNavisionSettingModal"
                            @row-click="goToDetail"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{ row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-4 d-flex align-items-center filterCompany">
                                    <span class="mr-3 title">Finance Company</span>
                                    <gofix-form-dropdown
                                        class="highlightDropdown chartOfAccountDropdown"
                                        label=""
                                        vLabel="name"
                                        :reduce="option => option.id"
                                        :searchable="false"
                                        placeholder="Filter by company"
                                        :options="financeCompanies"
                                        v-model="coa_company_filter" />
                                </div>
                            </template>
                        </gofix-default-table >
                        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="models.title" hide-footer :centered="true" v-model="models.open" @hidden="hiddenModel">
                            <b-form class="pb-20">
                                <gofix-form-dropdown
                                    label="Finance Company"
                                    vLabel="name"
                                    :required="true"
                                    :reduce="option => option.id"
                                    v-model="models.data.coa_company_id"
                                    :options="financeCompanies" />
                                <gofix-form-dropdown
                                    label="Type"
                                    vLabel="reference_value_text"
                                    v-model="navision_file_type"
                                    :options="selectNavisionFileTypesOptions" />
                                <gofix-form-input label="Prefix" v-model="models.data.file_name_prefix" />
                                <gofix-form-input label="Description" v-model="models.data.header_row_description" />
                            </b-form>
                            <b-button-group class="d-block text-right">
                                <gofix-button label="SUBMIT" @click="createNavisionSetting" :loading="models.loading" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'navision-file-config',
        components: {},
        data () {
            let filterDepartmentCode = JSON.parse(JSON.stringify(filters['navision_setting_config_menu']));
            return {
                tableConfig:{
                    name: 'finance-navision-file-config',
                    controls:{
                        create: this.$checkRole(this.$accessModule.navision_file_config, 'create'),
                        delete: this.$checkRole(this.$accessModule.navision_file_config, 'delete'),
                        update: this.$checkRole(this.$accessModule.navision_file_config, 'update'),
                        createTooptip:"Add Navision Setting"
                    },
                    filter: filterDepartmentCode,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                    itemSelected: [],
                },
                tableItems:[],
                models:{
                    open: false,
                    loading: false,
                    title:"Add Navision Setting",
                    data:{
                        id: null,
                        navision_file_type: null,
                        navision_file_type_id: null,
                        file_name_prefix: null,
                        header_row_description: null,
                        coa_company_id: null
                    }
                },
                selectNavisionFileTypesOptions : [],
                navision_file_type : null,
                financeCompanies:[],
                coa_company_filter: null,
            }
        },
        computed: {},
        watch: {
            coa_company_filter: function (val) {
                this.models.data.coa_company_id = val
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        created() {
            this.getNavisionFileTypes()
            this.getFinanceCompanies()
        },
        methods:{
            async createNavisionSettingModal(){
                this.models.title = 'Add Navision Setting';
                this.models.open = true
            },
            /*---------------------Fm code------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(this.coa_company_filter){
                    tableRequest.filter.coa_company_id.value = this.coa_company_filter;
                }
                await this.$store.dispatch("NavisionSettingController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load items", "danger");
                        reject();
                    })
            },
            goToDetail(item){
                if(!this.$checkRole(this.$accessModule.navision_file_config, 'update')) return;
                this.models.title = 'Edit Navision Setting';
                this.models.data = Object.assign({}, {
                    id: item.id,
                    navision_file_type: item.navision_file_type,
                    navision_file_type_id: item.navision_file_type_id,
                    file_name_prefix: item.file_name_prefix,
                    header_row_description: item.header_row_description,
                    coa_company_id: item.coa_company_id,
                });

                this.navision_file_type = item.get_navision_file_type ? item.get_navision_file_type : null
                this.models.open = true;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("NavisionSettingController/deleteItems", ids)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            createNavisionSetting(){
                if (!this.models.data.coa_company_id) {
                    return this.$alertNotification("Finance company is a required field.", "danger");
                }
                if (!this.navision_file_type) {
                    return this.$alertNotification("Type is a required field.", "danger");
                }
                if (!this.models.data.file_name_prefix) {
                    return this.$alertNotification("Prefix is a required field.", "danger");
                }
                let action = "createItem"
                let keyMessage= 'adding'
                if(this.models.data.id){
                    action = "updateItem"
                    keyMessage = 'editing'
                }
                this.models.data.navision_file_type = this.navision_file_type.reference_value_text
                this.models.data.navision_file_type_id = this.navision_file_type.id
                this.models.loading = true;
                this.$store.dispatch(`NavisionSettingController/${action}`, this.models.data)
                    .then(result => {
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'navision_setting'));
                        this.models.loading = false;
                        this.models.open = false;
                    })
                    .catch(error => {
                        this.models.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) {
                                return this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                            this.$alertNotification("Error!", "danger");
                        }
                    })
            },

            /*---- Models -----------------------*/
            hiddenModel(){
                this.models.title = "Add Navision Setting";
                this.models.data = {
                    id: null,
                    property_id: null,
                    property: null,
                    dept_code: null
                }
                this.navision_file_type = null
            },
            getNavisionFileTypes(){
                let filter = {reference_type: "Navision File Type"}
                let params = {filter: filter, limit: 100, isCMS: true }
                this.$store.dispatch(`PropertyController/getReferences`, params)
                    .then(response => {
                        this.selectNavisionFileTypesOptions = response.data.data.items;
                    })
            },
            getFinanceCompanies(){
                this.$store.dispatch("ChartOfAccountController/getCompanies", {
                    limit: -1,
                    page: 1
                })
                .then(response => {
                    this.financeCompanies = response.items;
                })
                .catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>
